<template>
    <header class="fixed z-[100000] py-[clamp(6px,2vw,24px)] bg-transparent w-full">
        <!-- Header 主容器：根據 Figma 設計調整 -->
        <nav class="flex items-center justify-center px-[3.75%] lg:pl-[5%] lg:pr-[3.75%] h-full relative z-10"
            role="navigation" aria-label="主導航">
            <div class="flex items-center justify-between w-full">
                <!-- 漢堡選單按鈕 -->
                <button id="mobile-menu-button"
                    class="absolute flex flex-col justify-center items-center  focus:outline-none top-[clamp(12px,2vw,22px)] right-[3%] lg:right-[1.5%] cursor-pointer group"
                    aria-expanded="false" aria-controls="mobile-menu" @click="toggleMobileMenu">
                    <div class="w-[95px] lg:w-[149px]">
                        <NuxtImg src="/img/all/menu.webp" alt="" class="w-full h-full object-cover"/>
                    </div>
                    <div
                        class="absolute top-[50%] left-[30%] translate-x-[-50%] translate-y-[-50%] text-[clamp(14px,2vw,16px)] text-dark-blue  font-Aldrich">
                        MENU
                    </div>
                </button>
            </div>

        </nav>

        <!-- 選單遮罩 -->
        <div id="mobile-menu-overlay"
            class="fixed inset-0 bg-[#454545]/20 opacity-0 invisible transition-all duration-300 z-[998]"
            @click="closeMobileMenu" />

        <!-- 選單 -->
        <div id="mobile-menu-container"
            class="fixed top-0 right-0 w-full h-full bg-opacity-80 opacity-0 invisible transition-all duration-300  z-[999] "
            @click="closeMobileMenu">
            <div id="mobile-menu"
                class="absolute top-0 right-0 w-full md:w-[50%] 2xl:w-[32.5%] h-[90%] flex flex-col transform translate-x-full transition-transform duration-300 overflow-y-auto bg-[url('/img/all/menu-bg.svg')] bg-cover bg-center bg-no-repeat  "
                @click.stop>
                <div class="flex items-center justify-between  pl-[30px] pr-[14px]  relative z-[100000]">
                    <!-- 關閉按鈕 -->
                    <!-- 漢堡選單按鈕 -->
                    <button id="mobile-menu-close"
                        class="absolute flex flex-col justify-center items-center  focus:outline-none top-[clamp(18px,3vw,48px)] right-[3%] lg:right-[5%] cursor-pointer group"
                        aria-expanded="false" aria-controls="mobile-menu" @click="closeMobileMenu">
                        <div class="w-[95px] lg:w-[149px]">
                            <NuxtImg src="/img/all/menu.webp" alt="" class="w-full h-full object-cover"/>
                        </div>
                        <div
                            class="absolute top-[50%] left-[30%] translate-x-[-50%] translate-y-[-50%] text-[clamp(14px,2vw,16px)] text-dark-blue  font-Aldrich">
                            close
                        </div>
                    </button>
                </div>


                <!-- 內容 -->
                <nav
                    class="relative  pt-[110px]  flex flex-col gap-[32px] px-[7.5%] lg:px-[10%] 3xl:pl-[100px] 3xl:pr-[150px]">
                    <NuxtLink    to="/" class="max-w-[241px] relative">
                        <div class="absolute top-[-30px] left-0 mix-blend-screen w-[90%]">
                            <NuxtImg src="/img/all/menu-dot.webp" alt="" class="w-full h-full object-cover" />
                        </div>
                        <div class="w-full relative">
                            <NuxtImg src="/img/all/menu-logo.webp" alt="" class="w-full h-full object-cover" />
                        </div>
                    </NuxtLink>
                    <ul class="flex flex-col gap-[clamp(16px,2vw,32px)] w-full">
                        <li class=" relative group w-full max-w-[255px]">
                            <NuxtLink to="/about" class="  text-white flex   relative  ">
                                <div
                                    class="flex lg:w-full  gap-[10px] border-b border-skyblue group-hover:border-green transition-all duration-300">
                                    <p
                                        class="text-[clamp(16px,2vw,20px)] group-hover:translate-x-[5px] transition-all duration-300">
                                        黃能富教授的創新與成就</p>
                                    <div class="relative w-[24px]">
                                        <NuxtImg src="/img/all/menu-text-dot.svg" alt=""
                                            class="w-full h-full object-contain group-hover:hidden" />
                                        <NuxtImg src="/img/all/menu-text-dot-h.svg" alt=""
                                            class="w-full h-full object-contain group-hover:block hidden" />
                                    </div>


                                </div>
                                <div
                                    class="relative right-[-6px] lg:right-[-7px] w-[1px] h-[29px] bg-skyblue group-hover:bg-green rotate-[30deg] bottom-[-2px] lg:bottom-[-3px] transition-all duration-300">
                                </div>

                            </NuxtLink>
                        </li>

                        <li class=" relative group w-full max-w-[175px]">
                            <NuxtLink to="/moocs" class="  text-white flex   relative  ">
                                <div
                                    class="flex lg:w-full  gap-[10px] border-b border-skyblue group-hover:border-green transition-all duration-300">
                                    <p
                                        class="text-[clamp(16px,2vw,20px)] group-hover:translate-x-[5px] transition-all duration-300">
                                        創辦清大磨課師</p>
                                    <div class="relative w-[24px]">
                                        <NuxtImg src="/img/all/menu-text-dot.svg" alt=""
                                            class="w-full h-full object-contain group-hover:hidden" />
                                        <NuxtImg src="/img/all/menu-text-dot-h.svg" alt=""
                                            class="w-full h-full object-contain group-hover:block hidden" />
                                    </div>


                                </div>
                                <div
                                    class="relative right-[-6px] lg:right-[-7px]  w-[1px] h-[29px] bg-skyblue group-hover:bg-green rotate-[30deg] bottom-[-2px] lg:bottom-[-3px] transition-all duration-300">
                                </div>

                            </NuxtLink>
                        </li>
                        <li class=" relative group w-full max-w-[255px] group" @mouseenter="handleSubmenuHover(true)"
                            @mouseleave="handleSubmenuHover(false)">
                            <div class="  text-white flex   relative  cursor-pointer" @click="toggleSubmenu">
                                <div class="flex lg:w-full  gap-[10px] border-b transition-all duration-300 group-hover:border-green"
                                    :class="isSubmenuOpen ? 'border-green' : 'border-skyblue'">
                                    <p class="text-[clamp(16px,2vw,20px)] transition-all duration-300 group-hover:translate-x-[5px]"
                                        :class="isSubmenuOpen ? 'translate-x-[5px]' : ''">
                                        智慧精準農業及其他應用</p>
                                    <div class="relative w-[24px]">
                                        <NuxtImg src="/img/all/menu-text-dot.svg" alt=""
                                            class="w-full h-full object-contain group-hover:hidden"
                                            :class="isSubmenuOpen ? 'hidden' : 'block'" />
                                        <NuxtImg src="/img/all/menu-text-dot-h.svg" alt=""
                                            class="w-full h-full object-contain group-hover:block"
                                            :class="isSubmenuOpen ? 'block' : 'hidden'" />
                                    </div>


                                </div>
                                <div class="relative right-[-6px] lg:right-[-7px]  w-[1px] h-[29px] rotate-[30deg] bottom-[-2px] lg:bottom-[-3px] transition-all duration-300 group-hover:bg-green"
                                    :class="isSubmenuOpen ? 'bg-green' : 'bg-skyblue'">
                                </div>

                            </div>
                            <ul class="overflow-hidden " :class="isSubmenuOpen ? 'max-h-[200px] mt-[16px]' : 'max-h-0'">
                                <li class="mb-[12px] group/menu-li ">
                                    <NuxtLink to="/ai01"
                                        class="text-white text-[clamp(14px,1.5vw,16px)] transition-colors duration-300 flex items-end gap-[8px]"
                                        :class="isSubmenuOpen ? 'text-green' : 'text-white'">
                                        <div class="w-[18px] flex-shrink-0   group-hover/menu-li:block transition-all duration-1000"
                                            :class="isSubmenuOpen ? 'hidden' : 'block'">
                                            <NuxtImg src="/img/all/menu-li-dot.webp" alt=""
                                                class="w-full h-full object-cover" />
                                        </div>
                                        <span>AI智慧精準農業</span>
                                    </NuxtLink>
                                </li>
                                <li class="mb-[12px] group/menu-li ">
                                    <NuxtLink to="/ai02" 
                                        class="text-white text-[clamp(14px,1.5vw,16px)] transition-colors duration-300 flex items-end gap-[8px]"
                                        :class="isSubmenuOpen ? 'text-green' : ''">
                                        <div class="w-[18px] flex-shrink-0 group-hover/menu-li:block transition-all duration-300"
                                            :class="isSubmenuOpen ? 'hidden' : 'block'">
                                            <NuxtImg src="/img/all/menu-li-dot.webp" alt=""
                                                class="w-full h-full object-cover" />
                                        </div>
                                        <span>AI智慧化管理與區塊鏈</span>
                                    </NuxtLink>
                                </li>
                                <li class="mb-[12px] group/menu-li ">
                                    <NuxtLink to="/ai03"
                                        class="text-white text-[clamp(14px,1.5vw,16px)] transition-colors duration-300 flex items-end gap-[8px]"
                                        :class="isSubmenuOpen ? 'text-green' : ''">
                                        <div class="w-[18px] flex-shrink-0   group-hover/menu-li:block transition-all duration-300"
                                            :class="isSubmenuOpen ? 'hidden' : 'block'">
                                            <NuxtImg src="/img/all/menu-li-dot.webp" alt=""
                                                class="w-full h-full object-cover" />
                                        </div>
                                        <span>農業應用</span>
                                    </NuxtLink>
                                </li>
                                <li class="mb-[12px] group/menu-li ">
                                    <NuxtLink to="/ai04"
                                        class="text-white text-[clamp(14px,1.5vw,16px)] transition-colors duration-300 flex items-end gap-[8px]"
                                        :class="isSubmenuOpen ? 'text-green' : ''">
                                        <div class="w-[18px] flex-shrink-0   group-hover/menu-li:block transition-all duration-300"
                                            :class="isSubmenuOpen ? 'hidden' : 'block'">
                                            <NuxtImg src="/img/all/menu-li-dot.webp" alt=""
                                                class="w-full h-full object-cover" />
                                        </div>
                                        <span>AI作物辨識引擎技術</span>
                                    </NuxtLink>
                                </li>
                            </ul>
                        </li>
                        <li class=" relative group w-full max-w-[310px]">
                            <NuxtLink to="/aimaker" class="  text-white flex   relative  ">
                                <div
                                    class="flex lg:w-full  gap-[10px] border-b border-skyblue group-hover:border-green transition-all duration-300">
                                    <p
                                        class="text-[clamp(16px,2vw,20px)] group-hover:translate-x-[5px] transition-all duration-300 ">
                                        AIMaker實作型AI人才培育平台</p>
                                    <div class="relative w-[24px]">
                                            <NuxtImg src="/img/all/menu-text-dot.svg" alt=""
                                            class="w-full h-full object-contain group-hover:hidden" />
                                        <NuxtImg src="/img/all/menu-text-dot-h.svg" alt=""
                                            class="w-full h-full object-contain group-hover:block hidden" />
                                    </div>


                                </div>
                                <div
                                    class="relative right-[-6px] lg:right-[-7px]  w-[1px] h-[29px] bg-skyblue group-hover:bg-green rotate-[30deg] bottom-[-2px] lg:bottom-[-3px] transition-all duration-300">
                                </div>

                            </NuxtLink>
                        </li>
                        <li class=" relative group w-full max-w-[115px]">
                            <NuxtLink to="/series" class="  text-white flex   relative  ">
                                <div
                                    class="flex lg:w-full  gap-[10px] border-b border-skyblue group-hover:border-green transition-all duration-300">
                                    <p
                                        class="text-[clamp(16px,2vw,20px)] group-hover:translate-x-[5px] transition-all duration-300">
                                        系列講座</p>
                                    <div class="relative w-[24px]">
                                        <NuxtImg src="/img/all/menu-text-dot.svg" alt=""
                                            class="w-full h-full object-contain group-hover:hidden" />
                                        <NuxtImg src="/img/all/menu-text-dot-h.svg" alt=""
                                            class="w-full h-full object-contain group-hover:block hidden" />
                                    </div>


                                </div>
                                <div
                                    class="relative right-[-6px] lg:right-[-7px]  w-[1px] h-[29px] bg-skyblue group-hover:bg-green rotate-[30deg] bottom-[-2px] lg:bottom-[-3px] transition-all duration-300">
                                </div>

                            </NuxtLink>
                        </li>
                    </ul>
                </nav>

            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
// 手機選單狀態
const isMobileMenuOpen = ref(false)

// 子菜單展開狀態
const isSubmenuOpen = ref(false)
const isSubmenuClicked = ref(false)


// 切換手機選單
const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
    updateMobileMenuState()
}

// 關閉手機選單
const closeMobileMenu = () => {
    isMobileMenuOpen.value = false
    isSubmenuOpen.value = false
    isSubmenuClicked.value = false
    updateMobileMenuState()
}

// 切換子菜單（點擊）
const toggleSubmenu = () => {
    isSubmenuClicked.value = true
    isSubmenuOpen.value = !isSubmenuOpen.value
}

// 處理hover事件（已停用，完全依賴點擊）
const handleSubmenuHover = (isHover: boolean) => {
    // 所有設備都不響應hover，完全依賴點擊
    return
}

// 更新手機選單狀態
const updateMobileMenuState = () => {
    const overlay = document.getElementById('mobile-menu-overlay')
    const container = document.getElementById('mobile-menu-container')
    const menu = document.getElementById('mobile-menu')
    const menuButton = document.getElementById('mobile-menu-button')
    const closeButton = document.getElementById('mobile-menu-close')

    if (isMobileMenuOpen.value) {
        // 開啟選單
        overlay?.classList.remove('opacity-0', 'invisible')
        overlay?.classList.add('opacity-100', 'visible')

        container?.classList.remove('opacity-0', 'invisible')
        container?.classList.add('opacity-100', 'visible')

        menu?.classList.remove('translate-x-full')
        menu?.classList.add('translate-x-0')

        // 更新aria-expanded
        menuButton?.setAttribute('aria-expanded', 'true')
        closeButton?.setAttribute('aria-expanded', 'true')

        // 防止body滾動
        document.body.style.overflow = 'hidden'
    } else {
        // 關閉選單
        overlay?.classList.remove('opacity-100', 'visible')
        overlay?.classList.add('opacity-0', 'invisible')

        container?.classList.remove('opacity-100', 'visible')
        container?.classList.add('opacity-0', 'invisible')

        menu?.classList.remove('translate-x-0')
        menu?.classList.add('translate-x-full')

        // 更新aria-expanded
        menuButton?.setAttribute('aria-expanded', 'false')
        closeButton?.setAttribute('aria-expanded', 'false')

        // 恢復body滾動
        document.body.style.overflow = ''
    }
}

// 監聽ESC鍵關閉選單
const handleKeydown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && isMobileMenuOpen.value) {
        closeMobileMenu()
    }
}

// 組件掛載時添加事件監聽器
onMounted(() => {
    document.addEventListener('keydown', handleKeydown)

    // 確保初始狀態正確
    updateMobileMenuState()
})

// 組件卸載時移除事件監聽器
onUnmounted(() => {
    document.removeEventListener('keydown', handleKeydown)
})
</script>